import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  
  protected apiUrl = `${environment.apiUrl}/api`;
  constructor(protected httpClient: HttpClient) {
  }
  get<T>(url: string,options?: object): Observable<T[]> {
    let _url = this.apiUrl;
    if(url){
      _url +=`/${url}`;
    }
    return this.httpClient.get<T[]>(_url, options);
  }
  
  getById<T>(url: string,id: any,options?: object): Observable<T>{
    return this.httpClient.get<T>(`${this.apiUrl}/${url}/${id}`, options);
  }

  delete<T>(url: string, id: any, options?: object): Observable<T>{
    return this.httpClient.delete<T>(`${this.apiUrl}/${url}/${id}`, options);
  }

  put<T>(url: string, data: any, options?: object): Observable<T>{
    let _url = this.apiUrl;
    if(url){
      _url +=`/${url}`;
    }
    return this.httpClient.put<T>(_url, data, options);
  }
  putById<T>(url: string, id:any,data: any, options?: object): Observable<T>{
    let _url = this.apiUrl;
    if(url){
      _url +=`/${url}/${id}`;
    }
    return this.httpClient.put<T>(_url, data, options);
  }

  post<T>(url: string, data:any, options?: object):Observable<T>{
    let _url = this.apiUrl;
    if(url){
      _url +=`/${url}`;
    }
    return this.httpClient.post<T>(_url, data, options);
  }
  
}
